module.exports = __webpack_public_path__ + "img/comment-img-3.82a027b7.jpg";